import { api } from "@/lib/api"

/**
 * Los DATOS de base que el modelo financiero necesita y que hasta ahora solo
 * entraban por `seeds/`: cuentas bancarias y tipos de cambio.
 *
 *   GET   /api/finance/bancos
 *   POST  /api/finance/bancos
 *   PATCH /api/finance/bancos/{id}/sociedad
 *   GET   /api/finance/tipos-cambio       ?moneda&limite
 *   POST  /api/finance/tipos-cambio
 *
 * SIN MODO MOCK, al igual que la carga por archivo: esto escribe, y un mock
 * que responde «creada» sin crear nada es el defecto que no se puede permitir.
 * Las pantallas de lectura de `finance/api.ts` sí lo tienen, y ahí sirve.
 */

export interface CuentaBancaria {
  id: string
  nombre: string
  moneda: string | null
  saldo_inicial: number | null
  saldo_final: number | null
  origen: string | null
  entity_id: string | null
  razon_social: string | null
  pais: string | null
}

export function fetchBancos(): Promise<CuentaBancaria[]> {
  return api.get<CuentaBancaria[]>("/finance/bancos")
}

export function crearBanco(payload: {
  nombre: string
  moneda: string
  entity_id?: string | null
  saldo_inicial?: number | null
  saldo_final?: number | null
  motivo: string
}): Promise<{ id: string; nombre: string; aviso: string | null }> {
  return api.post("/finance/bancos", payload)
}

/**
 * Asigna una cuenta a su sociedad. Es la accion que cierra el aviso de la
 * tesoreria.
 *
 * Marty SUGIERE por nombre y moneda y nunca decide, porque asignar mal pone la
 * caja de una sociedad en otra **y el total del grupo sigue cuadrando**: no hay
 * ninguna cifra que se descuadre para avisarlo. Esto es la confirmacion humana
 * de esa sugerencia, y por eso exige motivo.
 */
export function asignarSociedad(
  cuentaId: string,
  payload: { entity_id: string; motivo: string },
): Promise<{ id: string; nombre: string; aviso: string | null }> {
  return api.patch(`/finance/bancos/${cuentaId}/sociedad`, payload)
}

export interface Cotizacion {
  fecha: string
  moneda: string
  tipo_cambio: number | string
  origen: string | null
}

export interface CoberturaFx {
  moneda: string
  filas: number
  desde: string
  hasta: string
}

export interface TiposDeCambio {
  cotizaciones: Cotizacion[]
  cobertura: CoberturaFx[]
  convencion: string
}

export function fetchTiposDeCambio(moneda?: string): Promise<TiposDeCambio> {
  return api.get<TiposDeCambio>("/finance/tipos-cambio", {
    query: { moneda: moneda || undefined },
  })
}

export function cargarTiposDeCambio(payload: {
  tipos: { fecha: string; moneda: string; tipo_cambio: number }[]
  motivo: string
}): Promise<{ creados: number; actualizados: number; rechazados: string[] }> {
  return api.post("/finance/tipos-cambio", payload)
}
